/*
 * 游戏模块
 * */
import request from "@utils/request";

/**
 * 获取游戏列表
 * @returns {*}
 */
export function game_list() {
  return request.get("/game_list");
}
/**
 * 猜奇偶 获取开奖记录
 * @returns {*}
 */
export function guessOddList(data) {
  return request.get("/game/guess_odd",data,{ login: false });
}
/**
 * 根据订单号获取游戏类型
 * @returns {*}
 */
export function get_game_config(id) {
  return request.get("/guess_odd/get_game_config/"+id);
}
/**
 * 根据游戏类型获取游戏初始化信息
 * type:game_type String
 * @returns {*}
 */
export function get_game_data(type) {
  return request.get("/guess_odd/get_game_data/"+type);
}
/**
 * 根据根据期号和游戏id获取开奖结果
 * lottery_num:期号 number
 * type:游戏类型 24猜奇偶 28猜数字 默认24 number
 * @returns {*}
 */
export function lottery_result(data) {
  return request.get("guess_odd/lottery_result",data,{ login: false });
}

/**
 * 下注接口
 * @param {order_id,guess} 用户猜测 0偶数 1奇数
 * @returns {*}
 */
export function saveOrder(data) {
    return request.post("/guess_odd/saveOrder", data);
}

/**
 * 拉霸游戏
 * @param data
 * @returns {*}
 */
export function gameInit() {
  return request.get("/slot/game_init");
}
export function startSlot(data) {
  return request.post("/slot/start", data);
}
export function rwIn(data) {
  return request.post("/slot/rw_in", data);
}
export function rwOut(data) {
  return request.post("/slot/rw_out", data);
}
export function playAudio(file) {
  const audio = new Audio(require('../assets/images/slot/' + file + '.mp3'))
  audio.play()
}
